export default __webpack_public_path__ + "static/media/CrossDelete.d2d9b999.svg";